import React from 'react';

const SemanticLegend = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const configChoice = choices.find(c => c.kind === 'config');
  const results = question.results || [];

  const range = configChoice?.label || '-3a3';
  const parts = range.split('a');
  const min = parseInt(parts[0], 10);
  const max = parseInt(parts[1], 10);
  const rangeSpan = max - min;
  const zeroPos = rangeSpan > 0 ? (-min / rangeSpan) * 100 : 50;

  return (
    <div className="semantic-legend-container">
      {results.map(row => {
        const average = row.average !== undefined ? row.average : 0;
        const avgPos = rangeSpan > 0 ? ((average - min) / rangeSpan) * 100 : 50;

        const isPositive = average >= 0;
        const formattedAvg = isPositive ? `+${Number(average.toFixed(2))}` : `${Number(average.toFixed(2))}`;

        return (
          <div key={row.id || row.name} className="semantic-legend-row">
            {/* Left label (red, right-aligned) */}
            <div className="semantic-legend-label-left" title={row.name}>
              {row.name}
            </div>

            {/* Slider track area with center 0 and min/max ticks */}
            <div className="semantic-legend-track-wrapper">
              {/* Track Line */}
              <div className="semantic-legend-track-line">
                {/* Zero Marker */}
                <div className="semantic-legend-zero-marker" style={{ left: `${zeroPos}%` }} />

                {/* Filled Bar (green for positive, red for negative) */}
                {average > 0 && (
                  <div
                    className="semantic-legend-filled-bar positive"
                    style={{
                      left: `${zeroPos}%`,
                      width: `${avgPos - zeroPos}%`
                    }}
                  />
                )}
                {average < 0 && (
                  <div
                    className="semantic-legend-filled-bar negative"
                    style={{
                      left: `${avgPos}%`,
                      width: `${zeroPos - avgPos}%`
                    }}
                  />
                )}

                {/* End dot at average position */}
                <div
                  className={`semantic-legend-end-dot ${isPositive ? 'positive' : 'negative'}`}
                  style={{ left: `calc(${avgPos}% - 5px)` }}
                />
              </div>

              {/* Tick Labels */}
              <div className="semantic-legend-tick-labels">
                <span className="semantic-legend-tick" style={{ left: '0%' }}>
                  {min}
                </span>
                <span className="semantic-legend-tick" style={{ left: `${zeroPos}%` }}>
                  0
                </span>
                <span className="semantic-legend-tick" style={{ left: '100%' }}>
                  {max > 0 ? `+${max}` : max}
                </span>
              </div>
            </div>

            {/* Right label and average (green, left-aligned) */}
            <div className="semantic-legend-label-right">
              <span className={`semantic-legend-avg-val ${isPositive ? 'positive' : 'negative'}`}>{formattedAvg}</span>
              <span className="semantic-legend-right-text" title={row.rightLabel}>
                {row.rightLabel}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SemanticLegend;
